/**
 * AuditoriaMotivo
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {AuditoriaMotivoCollection} from '@/model/collection/AuditoriaMotivoCollection'

/* TODO: review generated class */
export class AuditoriaMotivo extends Resource {
  idMotivoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  nome: string | null = null
  ativo: boolean | null = null

  get $id() {
    return this.idMotivoPk
  }
  set $id(val) {
    this.idMotivoPk = val
  }
  get $tag() {
    return String(this.nome)
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of AuditoriaMotivo
   */
  async getAuditoriaMotivo(id: number) {
    return await Request.get(`/admin/auditoria-motivo/${id}`)
      .name('getAuditoriaMotivo')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of AuditoriaMotivo
   */
  async removeAuditoriaMotivo() {
    return await Request.delete(`/admin/auditoria-motivo/${this.$id}`)
      .name('removeAuditoriaMotivo')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of AuditoriaMotivo
   */
  static async listAuditoriaMotivo(params: any) {
    return await Request.get(`/admin/auditoria-motivo`, {params})
      .name('listAuditoriaMotivo')
      .as(AuditoriaMotivoCollection)
      .getData()
  }

  /**
   * Persists a new instance of AuditoriaMotivo. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistAuditoriaMotivo() {
    return await Request.post(`/admin/auditoria-motivo`, this)
      .name('persistAuditoriaMotivo')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of AuditoriaMotivo to use it in a CSV file
   */
  static async listCsvAuditoriaMotivo(params: any) {
    return await Request.get(`/admin/auditoria-motivo/csv`, {params})
      .name('listCsvAuditoriaMotivo')
      .as(AuditoriaMotivoCollection)
      .getData()
  }
}
